module.exports = __webpack_public_path__ + "static/from-third-world-to-first-b29383b1933779f44db23137aca70ad7.jpg";